import React, { useEffect } from 'react';
import { saveAs } from 'file-saver';
import styles from './AlertExportButton.module.css';
import { FloButton, FloComponentProps } from 'components';
import classnames from 'classnames';
import { AlertActionFilter } from 'model';
import { AlertTab } from 'model/state';
import { generateAlertFilter } from 'components/AlertsView/effect/useNotificationService';
import moment from 'moment';

interface AlertExportButtonProps extends FloComponentProps {
  alertExportCsvData: string | null;
  fetchAlertExportCsvData: (userId: string, filter: Partial<AlertActionFilter>) => void;
  clearAlertExportCsvData: () => void;
  fetchingCsvData: boolean;
  userId: string | null | undefined;
  currentTab: AlertTab;
  search: string;
  filters: Partial<AlertActionFilter>;
};

export const AlertExportButton: React.FC<AlertExportButtonProps> = React.memo(({
  className,
  alertExportCsvData,
  fetchAlertExportCsvData,
  clearAlertExportCsvData,
  fetchingCsvData,
  userId,
  currentTab,
  search,
  filters
}) => {
  useEffect(() => {
    if (alertExportCsvData !== null) {
      saveAs(new Blob([alertExportCsvData], {type: 'text/csv;charset=utf-8'}), `flo_alert_export_${moment().format('YYYY_MM_DD')}.csv`);
      clearAlertExportCsvData();
    }
  }, [alertExportCsvData, clearAlertExportCsvData]);

  const handleOnClick = () => {
    const alertFilter = generateAlertFilter(currentTab, 1, search, filters?.locationIds || [], filters?.alarmNames || [], filters?.activeOnly || false);
    fetchAlertExportCsvData(userId as string, alertFilter);
  };

  return (
    <>
      <FloButton
          className={classnames(className, styles.alertExportButton)}
          text={'Export'}
          onClick={handleOnClick}
          showLoader={fetchingCsvData}
          disabled={fetchingCsvData}
      />
    </>
  );
});
